import { render, staticRenderFns } from "./EditAlunos.vue?vue&type=template&id=7fb0c8ff&"
import script from "./EditAlunos.vue?vue&type=script&lang=js&"
export * from "./EditAlunos.vue?vue&type=script&lang=js&"
import style0 from "./EditAlunos.vue?vue&type=style&index=0&id=7fb0c8ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports